export default __webpack_public_path__ + "static/media/twitter.691b5f76.svg";